import { DataSourceType } from "@wingspanhq/payments/dist/interfaces";

// The v3 wire emits this requirement type ("EmployeeTaxForms" — see payments'
// requirementEnums v1↔v3 mapping), but the installed SDK enum predates it.
// Deliberately a LITERAL type (not a cast to the SDK enum): the supported-type
// union in ../types.ts extends by this literal, so keyed Records stay narrow.
// TODO: replace with RequirementType.EMPLOYEE_TAX_FORMS once the SDK ships it.
export const REQUIREMENT_TYPE_EMPLOYEE_TAX_FORMS = "EmployeeTaxForms" as const;

// v1 payments-interfaces cast — used by the (still-transitional) data layer.
export const DATA_SOURCE_TYPE_PAYER_PAYEE_ENGAGEMENT =
  "PayerPayeeEngagement" as DataSourceType;

/**
 * Comparison helper: SDK-typed `type` fields can't be `===`-compared to the
 * EmployeeTaxForms literal (no type overlap until the SDK ships the member).
 */
export const isEmployeeTaxFormsRequirementType = (
  type: string | undefined | null
): boolean => type === REQUIREMENT_TYPE_EMPLOYEE_TAX_FORMS;
